import React from 'react';
import { Row, Tabs, Tab, Panel, PanelGroup } from 'react-bootstrap';
import MediaQuery from 'react-responsive';


import CandidateOverview from '../../../components/Client/CandidateOverview/CandidateOverview';
import RecruiterComments from '../../../components/Client/RecruiterComments/RecruiterComments';
import Experience from '../../../components/Client/Experience/Experience';
import Skills from '../../../components/Client/Skills/skills';
import Languages from '../../../components/Client/Languages/Languages';
import Education from '../../../components/Client/Education/Education';
// import Training from '../../../components/Client/Training/Training';
import Hobby from '../../../components/Client/Hobby/Hobby';
// import ConsoleLog from '../../../hoc/ConsoleLog/ConsoleLog';

import './CandidatePreview.css';

const noDataString = "- Not Specified -";

/**
* @desc candidate profile view in expand mode
* @version 1.0.1
* @author Lakshmikanth
*/
const CandidatePreview = (props) => {
  
  let languageLength = 0;
  if(props.candidate.languages.length > 0) {
    props.candidate.languages.map((lang) => {
      if(lang.language.length > 0){
        languageLength++;
      }
    })
  }
  let skills = noDataString;
  var skillsArray = [];
  if(props.candidate.skills.length > 0){

    for(let i =0; i<props.candidate.skills.length ; i = i + 3){
      skillsArray.push(props.candidate.skills.slice(i,i+3));
    }
    
    skills = skillsArray.map((items,index) => {
      const groupedItems = items.map((item,itemindex) => {
        return (
            <Skills key={itemindex} skill={item}/>
        )
      })
      return (
        <div  className="skillrow">
          {groupedItems}
        </div>
      )
    });
    
  }

  let language = 0;
  const languagesList = props.candidate.languages.length > 0 ? props.candidate.languages.map((lang, index) => {
    if(lang.language.length > 0){
      language++;
      return  <Languages key={index} {...lang} />
    }
  }): noDataString;

  return (
    <div className="profile-preview-container">
        <div className="profile-preview">          
            <Tabs defaultActiveKey={1} id="uncontrolled-tab-example" className="profile-tabs" animation={false}>
              <Tab eventKey={1} title="Profile">
                <CandidateOverview 
                  candidate={props.candidate} 
                  candidate_id={props.candidate_id} 
                  candidate_status={props.candidate.candidate_status}
                  jobTitleId = {props.jobTitleId}
                  isProfileEdit={true}
                  isPreview={true}
                  print={false} 
                  handleCandidatePreview={props.handleCandidatePreview} 
                  handleProfileTabSelect={props.handleProfileTabSelect}
                />

                <MediaQuery query="(max-device-width: 767px)">
                  <PanelGroup 
                    activeKey={0}
                    onSelect={props.handleProfileTabSelect}
                    accordion 
                    id="profile-accordion" 
                  >
                    <Panel eventKey="recruiter">
                      <Panel.Heading>
                        <Panel.Title toggle>Recruiter's Comments</Panel.Title>
                      </Panel.Heading>
                      <Panel.Body collapsible>
                        <ul className="recruiter-comments">
                        {(props.candidate.recruiterComments) ? props.candidate.recruiterComments.split('<br>').map((comments, index) => (
                              comments ? <RecruiterComments key={index} text={comments} /> : null
                            )) : noDataString }
                        </ul>
                      </Panel.Body>
                    </Panel>
                    <Panel eventKey="experience">
                      <Panel.Heading>
                        <Panel.Title toggle>Experience</Panel.Title>
                      </Panel.Heading>
                      <Panel.Body collapsible>
                      {(props.candidate.experience.length > 0) ? props.candidate.experience.map((exp, index) => (
                            <Experience key={index} {...exp} />
                          )): noDataString}
                      </Panel.Body>
                    </Panel>
                    <Panel eventKey="skills">
                      <Panel.Heading>
                        <Panel.Title toggle>Skills</Panel.Title>
                      </Panel.Heading>
                      <Panel.Body collapsible>
                        <Row>
                        { (props.candidate.skills.length > 0 ) ? props.candidate.skills.map((skill, index) => (
                            <Skills key={index} skill={skill} />
                          )) : noDataString}
                        </Row>
                      </Panel.Body>
                    </Panel>
                    <Panel eventKey="education">
                      <Panel.Heading>
                        <Panel.Title toggle>Education and Training</Panel.Title>
                      </Panel.Heading>
                      <Panel.Body collapsible>
                        <Tabs
                          defaultActiveKey="education"
                          id="education-tabs"
                          >
                          <div className="tab-pane active" id="tab-education">
                            <Tab eventKey="education" title="Education">
                              { props.candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                <Education key={index} {...edu} />
                              )) }
                            </Tab>
                          </div>
                          <div className="tab-pane" id="tab-training"> 
                            <Tab eventKey="training" title="Training">
                              { props.candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                <Education key={index} {...train} />
                              )) }
                            </Tab>
                          </div>
                        </Tabs>
                      </Panel.Body>
                    </Panel>
                    {(languageLength > 0)?
                    <Panel eventKey="languages">
                      <Panel.Heading>
                        <Panel.Title toggle>Languages</Panel.Title>
                      </Panel.Heading>
                      <Panel.Body collapsible>
                          {language >0?languagesList:noDataString}
                      </Panel.Body>
                    </Panel>:""}
                    {(props.candidate.hobbies.length > 0)?
                      <Panel eventKey="hobbies" ref={(section) => { this.Experience = section; }}>
                        <Panel.Heading>
                          <Panel.Title toggle>Interests</Panel.Title>
                        </Panel.Heading>
                        <Panel.Body collapsible>
                          { props.candidate.hobbies.map((hobby, index) => (
                            <Hobby key={index} hobby={hobby} />
                          )) }
                        </Panel.Body>
                      </Panel>
                      :""}
                  </PanelGroup>
                </MediaQuery>
                <MediaQuery query="(min-device-width: 768px)">
                  <Tabs
                    className="profile-sub-tabs"
                    activeKey={props.profileTabKey}
                    onSelect={props.handleProfileTabSelect}
                    id="profile-tabs"
                    animation={false}
                    >
                      {/* Highlights Tab Starts*/}
                    <Tab eventKey="recruiter" title="Recruiter's Comments">
                      <div id="tab1">
                        <div className="panel panel-default">
                          <div className="panel-heading">
                              <h4 className="panel-title">
                                <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseOne">
                                Recruiter Comments
                              </a>
                              </h4>
                          </div>
                          <div id="collapseOne" className="panel-collapse collapse in">
                            <div className="panel-body rec">
                              {(props.candidate.recruiter_comments) ? props.candidate.recruiter_comments.split('\n').map((comments, index) => (
                                comments ? <RecruiterComments key={index} text={comments} /> : null
                              )) : noDataString }
                                
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    {/* Highlights Tab Ends*/}

                    {/* Experience Tab Starts*/}
                    <Tab eventKey="experience" title="Experience" >
                      <div id="tab2">
                        <div className="panel panel-default">
                          <div className="panel-heading">
                              <h4 className="panel-title">
                                <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseTwo">
                                Experience
                              </a>
                              </h4>
                          </div>
                          <div id="collapseTwo" className="panel-collapse collapse">
                            <div className="panel-body">
                              {(props.candidate.experience.length > 0) ? props.candidate.experience.map((exp, index) => (
                                <Experience key={index} {...exp} />
                              )): noDataString}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    {/* Experience Tab Ends*/}
                
                    {/* Skills Tab Starts*/}
                    <Tab eventKey="skills" title="Skills">
                      <div id="tab3">
                        <div className="panel panel-default">
                            <div className="panel-heading">
                              <h4 className="panel-title">
                                <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseThree">
                                Skills
                              </a>
                              </h4>
                            </div>
                          <div id="collapseThree" className="panel-collapse collapse">
                            <div className="panel-body ski">
                              {/* <h2>My Skills</h2> */}
                              {skills}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    {/* Skills Tab Ends*/}
                
                    {/* Education Tab Starts*/}   
                    <Tab eventKey="education" title="Education and Training">
                      <div id="tab4">
                        <div className="panel panel-default">
                          <div className="panel-heading">
                              <h4 className="panel-title">
                                <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseFour">
                                Education
                              </a>
                              </h4>
                            </div>
                          <div id="collapseFour" className="panel-collapse collapse">
                            <div className="panel-body">
                              { ((props.candidate.education.filter((edu) => edu.isTraining == 0).length > 0) && (props.candidate.education.filter((edu) => edu.isTraining == 1).length > 0)) ?
                                <div className="col-md-8 col-xs-offset-4">
                                  <ul role="tablist" className="nav nav-tabs">
                                    <li role="presentation" className="active">
                                      <a data-toggle="tab" href="#tab-education">Education</a>
                                    </li>
                                    <li role="presentation" className="">
                                      <a data-toggle="tab" href="#tab-training">Training</a>
                                      </li>
                                  </ul>
                                </div>
                                : 
                                ((props.candidate.education.filter((edu) => edu.isTraining == 0).length == 0) && (props.candidate.education.filter((edu) => edu.isTraining == 1).length == 0)) ? 
                                noDataString : "" 
                              }
                              <div className="clearfix"></div>
                              { ((props.candidate.education.filter((edu) => edu.isTraining == 0).length > 0) && (props.candidate.education.filter((edu) => edu.isTraining == 1).length > 0)) ?
                                <Tabs
                                  defaultActiveKey="education"
                                  id="eduation-tabs"
                                  animation={false}
                                  >
                                  <div className="tab-pane active" id="tab-education">
                                    <Tab eventKey="education" title="Education">
                                      { props.candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                        <Education key={index} {...edu} />
                                      )) }
                                    </Tab>
                                  </div>
                                  <div className="tab-pane" id="tab-training"> 
                                    <Tab eventKey="training" title="Training">
                                      { props.candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                        <Education key={index} {...train} />
                                      )) }
                                    </Tab>
                                  </div>
                                  
                              </Tabs>
                              :   
                              <div>
                              <div className="tab-pane active" id="tab-education">
                                { props.candidate.education.filter((edu) => { return edu.isTraining == 0; }).map((edu, index) => (
                                  <Education key={index} {...edu} />
                                )) }
                              </div>
                              <div className="tab-pane" id="tab-training">
                                { props.candidate.education.filter((edu) => { return edu.isTraining == 1; }).map((train, index) => (
                                  <Education key={index} {...train} />
                                )) }
                              </div>
                            </div> }
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>
                    {/* Education Tab Ends*/}      

                    {/* Languages Tab Starts*/}   
                    {(languageLength) >0?
                    <Tab eventKey="languages" title="Languages">
                      <div id="tab5">
                        <div className="panel panel-default">
                          <div className="panel-heading">
                            <h4 className="panel-title">
                              <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseFive">
                                Languages
                            </a>
                            </h4>
                          </div>
                          <div id="collapseFive" className="panel-collapse collapse">
                            <div className="panel-body lang">
                              {/* <h2>Languages</h2> */}
                              {language >0?languagesList:noDataString}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Tab>: ""}
                    {/* Languages Tab Ends*/}                      

                    {/* Hobbies Tab Starts*/}  
                    {(props.candidate.hobbies.filter(hobby => hobby.trim() !== '').length > 0)?
                      <Tab eventKey="hobbies" title="Interests">
                        <div id="tab6">
                          <div className="panel panel-default">
                            <div className="panel-heading">
                              <h4 className="panel-title">
                                <a data-toggle="collapse" data-parent=".tab-pane" href="#collapseSix">
                                  Interests
                              </a>
                              </h4>
                            </div>
                            <div id="collapseSix" className="panel-collapse collapse">
                              <div className="panel-body hob">
                                { props.candidate.hobbies.filter(hobby => hobby.trim() !== '').map((hobby, index) => (
                                  <Hobby key={index} hobby={hobby} />
                                )) }
                              </div>
                            </div>
                          </div>
                        </div>
                      </Tab>
                      :""}
                    {/* Hobbies Tab Ends*/}   
                  </Tabs>
                </MediaQuery>
                {/*Impleneting bootstrap tab end */}
              </Tab>
            </Tabs>
        </div>
      </div>
  );
}

export default CandidatePreview;


// WEBPACK FOOTER //
// ./src/components/Recruiter/CandidatePreview/CandidatePreview.js